module.exports = require("./ff-Latn-BF.js");